import { useMemo } from 'react';
import {
    useMixedGroupedTournamentsStoreCreator,
} from '../mixed-grouped.store';
import { replaceTopicPlaceholders } from '@om-fe/utils';
import { TOPIC_CATEGORY_TOURNAMENTS } from '@om-fe/core/components/grouped-match-list/store/grouped-match-list.constants';

export function useMixedGroupedCategoryStoreCreator(eventCategoryId: string) {
    const topic: string = useMemo((): string => replaceTopicPlaceholders(
        TOPIC_CATEGORY_TOURNAMENTS,
        { eventCategoryId: eventCategoryId ? eventCategoryId : '0' },
    ), [eventCategoryId]);

    return useMixedGroupedTournamentsStoreCreator(topic);
}
